// extracted by mini-css-extract-plugin
export default {"datesFiltersContainer":"datesFilters_datesFiltersContainer__FsLpb","collapsableComponent":"datesFilters_collapsableComponent__QS--C"};